"use client";

import { HINT } from "@/components/tool-kit/styles";

/**
 * The speed–distance–time triangle: distance on top, speed and time below. The quantity
 * being found is shaded — cover it and the other two show the formula.
 */
type Quantity = "distance" | "speed" | "time";

export interface TriangleLabels {
  title: string;
  distance: string;
  speed: string;
  time: string;
  caption: string;
}

const TOP = "100,8 153.2,100 46.8,100";
const LEFT = "46.8,100 100,100 100,167 8,167";
const RIGHT = "100,100 153.2,100 192,167 100,167";

function Cell({
  points,
  active,
  x,
  y,
  label,
}: {
  points: string;
  active: boolean;
  x: number;
  y: number;
  label: string;
}) {
  return (
    <g>
      <polygon
        fill="currentColor"
        fillOpacity={active ? 0.18 : 0}
        points={points}
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <text
        dominantBaseline="middle"
        fill="currentColor"
        fontSize={active ? 30 : 26}
        fontWeight={active ? 700 : 500}
        textAnchor="middle"
        x={x}
        y={y}
      >
        {label}
      </text>
    </g>
  );
}

export function DstTriangle({
  unknown,
  labels,
}: {
  unknown: Quantity;
  labels: TriangleLabels;
}) {
  return (
    <figure className="m-0 flex flex-col items-center gap-2">
      <svg
        aria-label={labels.title}
        className="h-auto w-44 text-foreground"
        role="img"
        viewBox="0 0 200 175"
      >
        <Cell
          active={unknown === "distance"}
          label={labels.distance}
          points={TOP}
          x={100}
          y={72}
        />
        <Cell
          active={unknown === "speed"}
          label={labels.speed}
          points={LEFT}
          x={58}
          y={138}
        />
        <Cell
          active={unknown === "time"}
          label={labels.time}
          points={RIGHT}
          x={142}
          y={138}
        />
      </svg>
      <figcaption className={`${HINT} text-center`}>
        {labels.caption}
      </figcaption>
    </figure>
  );
}
